import {defineStore} from 'pinia';
import {watch} from 'vue';
import menuConfig from "@/js/menu.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";

export const useMenuStore = defineStore('menuStore', {
    state: () => ({
        isSidenavOpen: false,
        menuItems: menuConfig.menuItems,
    }),
    actions: {
        toggleSidenav() {
            this.isSidenavOpen = !this.isSidenavOpen
            this.setBodyOverflow()
        },
        closeSidenav() {
            if (this.isSidenavOpen) {
                this.isSidenavOpen = false
                this.setBodyOverflow()
            }
        },
        setBodyOverflow() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(this.isSidenavOpen)
        }
    }
});
